import BuildingPage from 'pages/BuildingPage';

const AdminApplications = (): JSX.Element => <BuildingPage />;

export default AdminApplications;
